import { fetchFamilyGroups } from '@/services/familyGroups'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  familyGroups: undefined
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  fetchFamilyGroups({ commit }, supplierId) {
    commit(mutationTypes.FETCHING)

    return fetchFamilyGroups(supplierId)
      .then((familyGroups) => {
        commit(mutationTypes.FETCHED, familyGroups)
      })
      .catch((err) => {
        console.log(err)
        commit(mutationTypes.FETCHED, [])
        throw err
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, familyGroups) {
    state.familyGroups = familyGroups
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
